<template>
  <figure>
    <img
      v-if="photoId"
      class="lazy"
      :alt="alt"
      :src="userImageUrl + photoId"
      data-test="img"
      @load="$emit('onLoadImage')"
      @error="$emit('onLoadImage')"
    >
    <figcaption
      v-if="caption"
      class="pega-pre-wrap"
      data-test="caption"
      v-text="caption"
    />
  </figure>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'
export default {
  mixins: [jobPreviewVisibilityCommon],
  props: {
    photoId: {
      type: Number,
      default: 0
    },
    alt: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: ''
    }
  }
}
</script>
